import { toast } from "react-toastify";
import {
  ScheduleSearchContainer,
  SchedulesContainer,
} from "../components/CampaignSchedules/index.js";

import { useLoaderData } from "react-router-dom";
import { customFetch } from "../utils/custom-fetch.js";
import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
export const loader = async ({ request }) => {
  const params = Object.fromEntries(
    new URL(request.url).searchParams.entries()
  );

  try {
    const { data } = await customFetch.get("/campaign-schedules", { params });

    const { data: companies } = await customFetch.get(
      "/buildings/maintenance-companies"
    );

    const maintenanceCompanies = [
      ...companies.map((company) => ({
        name: company.name,
        _id: company.value,
      })),
    ];

    return { data, maintenanceCompanies };
  } catch (err) {
    toast.error(err?.response?.data?.msg || "שגיאה בטעינת תזמונים", {
      toastId: "schedules-load-error",
    });
    throw err;
  }
};

/* ----------- Context  ----------- */
const AllSchedulesContext = createContext();
export const useAllSchedulesContext = () => useContext(AllSchedulesContext);

/* ----------- Page component ----- */
const AllCampaignSchedules = () => {
  const { data, maintenanceCompanies } = useLoaderData();
  const navigate = useNavigate();
  return (
    <AllSchedulesContext.Provider value={{ data, maintenanceCompanies }}>
      <button
        type="button"
        style={{ marginBottom: "1rem" }}
        className="btn btn-primary"
        onClick={() => navigate("/dashboard/add-advertisement")}
      >
        צור תזמון חדש
      </button>
      <ScheduleSearchContainer />
      <SchedulesContainer />
    </AllSchedulesContext.Provider>
  );
};

export default AllCampaignSchedules;
